import { render, staticRenderFns } from "./reports-training-costs.vue?vue&type=template&id=30f2c23c"
import script from "./reports-training-costs.vue?vue&type=script&lang=js"
export * from "./reports-training-costs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports